<template>
  <a-modal
    :title="modalTit"
    :visible="isLimitDialogShow"
    :footer="null"
    :mask-closable="false"
    width="627px"
    :confirm-loading="confirmLoading"
    @cancel="isLimitDialogShow=false"
  >
    <div class="order-info">
      <a-form label-width="100px">
        <a-form-item :label="`${orderNumberTxt}：`">
          {{ orderData.ordersn }}
        </a-form-item>
        <a-form-item :label="`${createTime}：`">
          {{ timestampToTime(orderData.addtime, '-').date }}
          {{ timestampToTime(orderData.addtime, '-').time }}
        </a-form-item>
        <a-form-item :label="`${orderConTit}：`">
          {{ orderData.proname }}
        </a-form-item>
        <a-form-item :label="`${serivceTimeTit}：`">
          {{ orderData.servicedate }}
        </a-form-item>
        <a-form-item :label="`${salePrice}：`">>
          {{ orderData.money }}
        </a-form-item>
        <a-form-item :label="`${orderPriceTit}：`">
          {{ orderData.money }}
        </a-form-item>
        <a-form-item :label="`${orderStatusTit}：`">
          <span
            v-if="orderData.paystatus === 0"
            class="wait-for-pay"
          >{{ orderData.paystatusname }}</span>
          <template v-else-if="orderData.paystatus===1">
            {{ orderData.paystatusname }}
            {{ timestampToTime(orderData.paytime, '-').date }}
            {{ timestampToTime(orderData.paytime, '-').time }}
          </template>
          <template v-else-if="orderData.paystatus===2">
            {{ orderData.paystatusname }}
            {{ timestampToTime(orderData.closetime, '-').date }}
            {{ timestampToTime(orderData.closetime, '-').time }}
            {{ orderData.closecause }}
          </template>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import { timestampToTime } from '@/store/account/scripts'
export default {
  components: {
  },
  props: {
    orderData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isLimitDialogShow: false,
      confirmLoading: false
    }
  },
  computed: {
    createTime () {
      return this.$t('message["126"]')
    },
    orderNumberTxt () {
      return this.$t('message["245"]')
    },
    orderPriceTit () {
      return this.$t('message["247"]')
    },
    orderConTit () {
      return this.$t('message["248"]')
    },
    modalTit () {
      return this.$t('message["249"]')
    },
    orderStatusTit () {
      return this.$t('message["250"]')
    },
    serivceTimeTit () {
      return this.$t('message["310"]')
    },
    salePrice () {
      return this.$t('message["1329"]')
    }
  },
  mounted () {
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    timestampToTime,
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    }

  }
}
</script>

<style lang="scss" scoped>
  .order-info::v-deep{
    .ant-row {
        padding-left: 100px;
        .ant-form-item-label {
          float: left;
          width: 90px;
          margin-left: -100px;
          color: #666;
          text-align: right;
        }
        .ant-form-item-control-wrapper {
          float: left;
          width: 100%;
        }
      }
  }
</style>
